module.exports = __webpack_public_path__ + "img/pcad-3dview.efa6104c.png";